// "Websites von Gastronaut" in the app catalog (public/apps.json). It is an
// agency service, not a self-service app: there is no activation button, the
// id never goes into restaurantData.apps (which is billed and which restaurant
// admins can write), and access comes only from a Gastronaut admin's
// activation in the API after a personal appointment.

export const MANAGED_WEBSITES_APP_ID = 'gastronaut-websites';

export const isManagedWebsitesApp = (id: string | null | undefined) => id === MANAGED_WEBSITES_APP_ID;

// The general sales appointment of gastronaut.ai (gastronaut-website
// src/content/contact.ts), configurable per environment.
export const WEBSITE_APPOINTMENT_URL =
  process.env.REACT_APP_WEBSITE_APPOINTMENT_URL ||
  'https://calendly.com/gastronaut-sales/erstes-kennenlernen-mit-gastronaut-tf';

export const websiteManagementPath = (restaurantId: string) => `/${restaurantId}/website`;
